import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { FaStar } from "react-icons/fa";

const reviews = [
  {
    name: "Vinith Kumar G",
    role: "Member",
    comment: "Maintenance is excellent and the courts are top quality. A perfect training destination.",
    avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=80&q=80",
  },
  {
    name: "Suriya",
    role: "Advanced Player",
    comment: "Coaching is excellent for beginners, intermediate and advanced players.",
    avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=80&q=80",
  },
  {
    name: "Gopika",
    role: "Community Member",
    comment: "Safe place for girls and ladies. The coaching is structured and supportive.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=80&q=80",
  },
];

const TestimonialsSection = () => {
  return (
    <section id="reviews" className="mx-auto max-w-7xl px-6 py-20 sm:px-8 lg:px-12">
      <div className="mb-12 max-w-3xl">
        <p className="text-sm uppercase tracking-[0.32em] text-emerald-300">Testimonials</p>
        <h2 className="section-heading mt-4">What our members say.</h2>
      </div>

      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={24}
        slidesPerView={1}
        loop={true}
        pagination={{ clickable: true }}
        autoplay={{ delay: 4200, disableOnInteraction: false }}
      >
        {reviews.map((review) => (
          <SwiperSlide key={review.name}>
            <div className="section-card flex flex-col gap-8 border border-white/10 bg-slate-900/80 p-8 text-slate-300 shadow-glass">
              <div>
                <p className="text-lg font-semibold text-white">{review.name}</p>
                <p className="text-sm text-emerald-300">{review.role}</p>
              </div>
              <div className="space-y-4">
                <div className="flex items-center gap-2 text-amber-300">
                  {Array.from({ length: 5 }).map((_, index) => (
                    <FaStar key={index} className="h-5 w-5" />
                  ))}
                </div>
                <p className="text-lg leading-8 text-slate-100">“{review.comment}”</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default TestimonialsSection;
